import NiceModal from '@ebay/nice-modal-react'
import { UserProfileModel } from 'mvppoker-portal-common/api'
import React from 'react'
import { createMVPModal } from '../Modal'
import { UserProfileModalView } from './UserProfileModalView'

class UserProfileModal
{
	Show(userProfile: UserProfileModel) 
	{
		NiceModal.show(createMVPModal('user-profile-modal', () =>
		{
			return <UserProfileModalView 
				userProfile={userProfile}
			/>
		}))
	}
}

const modal = new UserProfileModal()
export default modal
